import { ChangeEvent, FC, useRef } from 'react';

import { FLButton } from '@shared/ui';

import { processUploadFileEvent } from '../../lib';
import { convertToDataIdAttr } from '@shared/lib/utils/text.util';

import { buttonStyle } from './PrimaryUploadButton.tailwind';

interface PropsType {
  text: string;
  exts: string;
  onUpload: (file: File) => void;
}

const PrimaryUploadButton: FC<PropsType> = ({ text, exts, onUpload }) => {
  const ref = useRef<HTMLInputElement>(null);

  const handleUpload = (event: ChangeEvent<HTMLInputElement>) => {
    processUploadFileEvent(event, exts, onUpload);
  };

  return (
    <div className={buttonStyle}>
      <FLButton
        type="primary"
        text={text}
        onClick={() => ref.current?.click()}
        data-id={`button-${convertToDataIdAttr(text)}`}
      />
      <input
        ref={ref}
        type="file"
        className="hidden"
        onChange={handleUpload}
        accept={exts}
        data-id={`input-${convertToDataIdAttr(text)}`}
      />
    </div>
  );
};

export default PrimaryUploadButton;
